import ShareWechat from './components/app/ShareWechat.vue';
import { REPORT2025_DETAIL_UPDATE } from '@/store/mutationTypes';
export default {
  components: {
    ShareWechat
  },
  data() {
    return {
      isFocus: false
    };
  },
  computed: {
    path() {
      return this.$route.path;
    },
    keepAlive() {
      return (this.$route.meta || {}).keepAlive;
    },
    stateAudio() {
      const {
        audio
      } = this.$store.state;
      return audio;
    }
  },
  methods: {
    async fnResize() {
      if (this.isFocus) return;
      const deviceWidth = this.isInDingTalk ? this.$refs.wrap.clientWidth : document.documentElement.clientWidth || window.innerWidth;
      const deviceHeight = this.isInDingTalk ? this.$refs.wrap.clientHeight : document.documentElement.clientHeight || window.innerHeight;
      console.log('wrapclientHeight', this.$refs.wrap.clientHeight);
      console.log('window.screen.height', window.screen.height);
      console.log('document.documentElement.clientHeight', document.documentElement.clientHeight);
      const isFoldableScreen = parseInt(deviceHeight / deviceWidth * 1000) / 1000 < 1.4; // 是否折叠屏
      // 折叠屏vw计算比例
      // 内容比例
      // const viewportWidth = process?.env?.VUE_APP_VIEWPORT_WIDTH || 375;
      const currentWidthHeightRatio = deviceWidth / deviceHeight;
      const baseWidthHeightRatio = 375 / 812;
      let contentRatio = currentWidthHeightRatio >= baseWidthHeightRatio ? baseWidthHeightRatio / currentWidthHeightRatio : 1;
      const contentMaskColor = contentRatio === 1 ? 'transparent' : `rgba(0,0,0,0.5)`;
      // 视图比例
      const viewportRatio = isFoldableScreen ? baseWidthHeightRatio / currentWidthHeightRatio : 1;
      const viewportLeft = isFoldableScreen ? '0' : '0';
      const contentShareRatio = isFoldableScreen ? baseWidthHeightRatio / currentWidthHeightRatio : 1;
      console.log('--content-ratio', contentRatio);
      console.log(deviceWidth);
      console.log('--viewport-ratio', viewportRatio);
      document.documentElement.style.setProperty('font-size', `${deviceWidth / 30}px`);
      document.documentElement.style.setProperty('--content-ratio', contentRatio);
      document.documentElement.style.setProperty('--content-mask-color', contentMaskColor);
      document.documentElement.style.setProperty('--viewport-ratio', viewportRatio);
      document.documentElement.style.setProperty('--viewport-left', viewportLeft);
      document.documentElement.style.setProperty('--viewport-right', viewportLeft);
      document.documentElement.style.setProperty('--content-share-ratio', contentShareRatio);
      if (contentRatio < 0.5) {
        contentRatio = 0.5;
      }
      // const memory = navigator.deviceMemory || 4;
      // const isLowerDevice = memory <= 4 && !this.isApple;
      this.$store.commit('yearReport2025/' + REPORT2025_DETAIL_UPDATE, {
        contentRatio,
        isLowerDevice: true,
        deviceHeight
      });
      // console.log('deviceWidth============', isFoldableScreen, deviceWidth, deviceHeight, viewportRatio, contentRatio);
    }
  },
  beforeCreate() {
    // zeeho APP或小程序内webview无token时
    if ((this.isMiniapp || this.isApp) && !/token=[\w_-]+/.test(window.location.hash)) {
      localStorage.removeItem('token');
    }
  },
  mounted() {
    window.addEventListener('resize', this.fnResize);
    this.fnResize();
    // app兼容
    document.body.parentNode.className = document.body.parentNode.className + (this.isApp || this.isInDingTalk ? 'is-app' : '');
    // 解决ios不支持按钮:active伪类的方法
    document.body.addEventListener('touchstart', () => {});

    // 解决非虚拟键盘输入时，页面适配比例不变
    document.addEventListener('focus', () => {
      this.isFocus = true;
    }, true);
    document.addEventListener('blur', () => {
      this.isFocus = false;
    }, true);

    // 解决ios输入表单被键盘顶上后无法恢复的问题
    if (this.isApple) {
      let oldScrollTop = 0;
      let isFocus = false; // 防止输入框之前切换时界面上下滚动
      const handleFocus = e => {
        isFocus = true;
        // e.target.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          // console.log('focus');
          oldScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          isFocus = false;
          // ios 16系统键盘顶不上去
          function isiOS16() {
            var ua = navigator.userAgent;
            var iosVersionStr = /OS (\d+)_(\d+)_?(\d+)?/.exec(ua);
            var version = iosVersionStr ? parseInt(iosVersionStr[1], 10) : null;
            return version === 16;
          }
          if (['INPUT', 'TEXTAREA'].some(val => val === e.target.tagName) && oldScrollTop === 0 && isiOS16()) {
            document.documentElement.scrollTop = document.body.scrollHeight;
          }
        }, 100);
      };
      const handleBlur = () => {
        console.log(oldScrollTop, document.documentElement.scrollTop || document.body.scrollTop);
        setTimeout(() => {
          if (isFocus) return;
          if (window.scrollTo) {
            // console.log('blur');
            window.scrollTo(0, oldScrollTop);
          }
        }, 50);
      };
      document.addEventListener('focus', handleFocus, true);
      document.addEventListener('blur', handleBlur, true);
    }
  },
  watch: {
    $route: {
      deep: true,
      handler(newValue) {
        // 滚动条自动滚动5px，然后回位(避免ios回退偶现白屏)
        const meta = newValue.meta || {};
        console.log(meta);
        this.$nextTick(() => {
          if (window.scrollTo) {
            const scrollTop = document.documentElement.scrollTop + 5;
            window.scrollTo(0, document.documentElement.scrollHeight);
            window.scrollTo(0, scrollTop);
          }
        });

        // // 没有启用分享配置的页面使用默认分享配置
        // if (!meta.visibleShare) {
        //   this.$nextTick(() => {
        //     const { href } = window.location;
        //     homeJssdkSignApi({
        //       debug: this.$route.query.debug,
        //     }).then(() => {
        //       weixinShare({ link: `${href.split('#')[0]}` });
        //     });
        //   });
        // }
        if (!meta.visibleAudio) {
          this.$audio.pause();
        } else {
          // this.$audio.src = this.stateAudio.src;
          // this.$audio.src = `http://oss-cfmoto.zeehoev.com/codes/cfmoto-h5/music.mp3?t=${new Date().getTime()}`;
          // this.$audio.loop = true;
          // this.$audio.play();
        }
      }
    }
  }
};